module.exports = __webpack_public_path__ + "img/flow-img2-1.59ef74cb.png";